var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showMarker)?_c('div',{staticClass:"env-marker"},[_c('div',[_c('a-tag',{staticClass:"env-marker__tag",attrs:{"color":_vm.markerColor}},[_vm._v(_vm._s(_vm.markerText))])],1),_c('div',{staticClass:"env-marker__info"},[_c('div',[_vm._v("v"+_vm._s(_vm.packageVersion))]),_c('div',[_vm._v("build: #"+_vm._s(_vm.buildNo))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }